import type { HTMLAttributes } from 'react';
import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useStarterActions } from './hooks/useStarterActions';

export const StarterActions: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {
	const {
		data: { declareVictoryUrl, postUpdateUrl, showActions },
	} = useStarterActions();

	if (!showActions) return null;

	return (
		<div className="mt-[52px] max-w-[512px] rounded-xl border-none bg-[#FAF8FD] p-6 md:mt-[80px]" {...props}>
			<div className="mb-4 text-center">
				<Text variant="heading" size="x-small" className="mb-6">
					<Translate value="fe.pages.decision_maker_response.victory_prompt.title" />
				</Text>
			</div>

			<div className="flex flex-col justify-center gap-6 md:flex-row">
				<Button variant="secondary-solid" size="small" as="a" href={declareVictoryUrl} data-qa="declare-victory-button">
					<Translate value="fe.pages.decision_maker_response.victory_prompt.positive" />{' '}
					<Translate value="fe.pages.decision_maker_response.victory_prompt.positive_cta" />
				</Button>

				<Button variant="secondary-solid" size="small" as="a" href={postUpdateUrl} data-qa="post-update-button">
					<Translate value="fe.pages.decision_maker_response.victory_prompt.negative" />{' '}
					<Translate value="fe.pages.decision_maker_response.victory_prompt.negative_cta" />
				</Button>
			</div>
		</div>
	);
};
